export default function DTD_ElementsVsAttr() {
  return (
    <div>
      <h1>DTD_ElementsVsAttr</h1>
      <p>This is the DTD_ElementsVsAttr component.</p>
    </div>
  );
}